import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import PopModalError from './PopModalError';

const ExecutiveSalesList = ({ rows, handleMySalesDetails, handleClose, open }) => {
  return rows?.result?.length > 0 ? (
    <Grid item size={{ xs: 12, md: 12 }} className='container-2 my-sales'>
      <div style={{ height: 'auto', width: 'auto' }} className={'leads-list'}>
        {' '}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
            sx={{
              '&:hover': {
                color: 'white',
              },
            }}
          >
            <Typography>Ver Detalle</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell align='left'>Cantidad</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.result?.map((row) => (
                    <TableRow
                      key={row.date}
                      sx={{
                        '&:last-child td, &:last-child th': {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component='th' scope='row'>
                        {row.date}
                      </TableCell>
                      <TableCell align='right'>
                        <Button
                          variant='outlined'
                          sx={{
                            '&:hover': {
                              color: 'white',
                            },
                            margin: '10px',
                          }}
                          onClick={() => handleMySalesDetails(row.date)}
                        >
                          {row.total_sales}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
        <PopModalError handleClose={handleClose} open={open} />
      </div>
    </Grid>
  ) : (
    <Grid item size={{ xs: 4 }} className='container-2 my-sales'>
      <div style={{ height: 'auto', width: 'auto' }}>
        <Typography variant='h6' paddingLeft={2}>
          No hay datos disponibles
        </Typography>
      </div>
    </Grid>
  );
};

export default ExecutiveSalesList;
